var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiscoIntegrationIcon = function SvgDiscoIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 12,
    fill: "url(#disco-integration-icon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.392 31.505a1.896 1.896 0 1 0 0-3.792 1.896 1.896 0 0 0 0 3.792ZM34.288 25.991a2.24 2.24 0 1 0 0-4.481 2.24 2.24 0 0 0 0 4.481ZM28.417 23.367a2.068 2.068 0 1 0 0-4.137 2.068 2.068 0 0 0 0 4.137ZM22.532 25.61a1.896 1.896 0 1 0 0-3.792 1.896 1.896 0 0 0 0 3.792ZM20.08 31.308a1.724 1.724 0 1 0 0-3.448 1.724 1.724 0 0 0 0 3.448ZM22.495 37.192a1.724 1.724 0 1 0 0-3.447 1.724 1.724 0 0 0 0 3.447ZM28.366 39.645a1.724 1.724 0 1 0 0-3.448 1.724 1.724 0 0 0 0 3.447ZM34.25 37.4a1.896 1.896 0 1 0 0-3.791 1.896 1.896 0 0 0 0 3.792ZM36.703 31.704a2.068 2.068 0 1 0 0-4.137 2.068 2.068 0 0 0 0 4.137ZM39.359 21.226a2.585 2.585 0 1 0 0-5.171 2.585 2.585 0 0 0 0 5.17ZM32.523 15.994a2.413 2.413 0 1 0-3.412-3.413 2.413 2.413 0 0 0 3.412 3.413ZM22.812 17.251a2.068 2.068 0 1 0-2.924-2.925 2.068 2.068 0 0 0 2.924 2.925ZM15.788 23.786a1.724 1.724 0 1 0-2.438-2.438 1.724 1.724 0 0 0 2.438 2.438ZM14.166 33.133a1.551 1.551 0 1 0-2.194-2.194 1.551 1.551 0 0 0 2.194 2.194ZM17.42 41.958a1.379 1.379 0 1 0 0-2.758 1.379 1.379 0 0 0 0 2.758ZM27.062 46.028a1.551 1.551 0 1 0-2.194-2.194 1.551 1.551 0 0 0 2.194 2.194ZM36.651 44.65a1.724 1.724 0 1 0-2.437-2.437 1.724 1.724 0 0 0 2.438 2.437ZM43.675 38.114a2.068 2.068 0 1 0-2.925-2.925 2.068 2.068 0 0 0 2.925 2.925ZM45.419 28.889a2.413 2.413 0 1 0-3.413-3.413 2.413 2.413 0 0 0 3.413 3.413Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-integration-icon_svg__a",
    x1: 0.002,
    y1: 57.937,
    x2: 63.795,
    y2: 7.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })))));
};

export default SvgDiscoIntegrationIcon;